import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface CallActionButtonProps {
  icon: React.ReactNode;
  label: string;
  onClick: () => void;
  testId?: string;
  variant: "destructive" | "success";
}

/**
 * A ringing screen's round answer button, its label beneath it as on the
 * iPhone, where a longer answer ("End & Accept") still fits in any language.
 */
export function CallActionButton({
  label,
  icon,
  variant,
  onClick,
  testId,
}: CallActionButtonProps) {
  // We bypass the shadcn Button variants for the success case (not in the
  // default palette) and the round shape; use inline classes keyed off
  // tailwind tokens to keep dark-mode parity automatic.
  const bg =
    variant === "destructive"
      ? "bg-destructive text-destructive-foreground"
      : "bg-success text-success-foreground";

  return (
    <div className="flex w-24 flex-col items-center gap-2">
      <Button
        aria-label={label}
        className={cn(
          "flex h-20 w-20 items-center justify-center rounded-full shadow-lg",
          bg,
          "transition-transform hover:opacity-90 active:scale-95"
        )}
        data-testid={testId}
        onClick={onClick}
        type="button"
      >
        {icon}
      </Button>
      <span
        aria-hidden="true"
        className="text-center text-xs leading-tight font-medium text-foreground"
      >
        {label}
      </span>
    </div>
  );
}
